// Shared currency formatting utilities for BDT

export const formatCurrencyBDT = (
    amount: number,
    options?: {
        minimumFractionDigits?: number;
        maximumFractionDigits?: number;
        ignoreDecimals?: boolean;
    },
): string => {
    const ignoreDecimals = options?.ignoreDecimals ?? false;

    const formatter = new Intl.NumberFormat("en-BD", {
        style: "decimal",
        minimumFractionDigits: ignoreDecimals
            ? 0
            : (options?.minimumFractionDigits ?? 2),
        maximumFractionDigits: ignoreDecimals
            ? 0
            : (options?.maximumFractionDigits ?? 2),
    });

    const safeAmount = Number(amount);
    const formattedNumber = formatter.format(
        Number.isFinite(safeAmount) ? safeAmount : 0,
    );
    return `৳ ${formattedNumber}`;
};
